export default "__VITE_ASSET__B5ZvAFGl__"